// extracted by mini-css-extract-plugin
module.exports = {"input":"input--a79cb4"};